import f from "./index205.mjs";
import u from "./index328.mjs";
import o from "./index329.mjs";
import l from "./index212.mjs";
function Y(s, i) {
  l(2, arguments);
  var r = f(s), e = f(i), a = o(r, e), m = Math.abs(u(r, e));
  r.setFullYear(1584), e.setFullYear(1584);
  var n = o(r, e) === -a, t = a * (m - Number(n));
  return t === 0 ? 0 : t;
}
export {
  Y as default
};
//# sourceMappingURL=index251.mjs.map
